import * as React from "react";
import { StoreContext } from "../context/store-context";
import { addToCart as addToCartStyle } from "./add-to-cart.module.css";
import { useSeekaConverge } from '@seeka-labs/converge-react';


export function AddToCart({ variantId, quantity, available, product, title, vendor, metafield, ...props }) {
  const { addVariantToCart, loading } = React.useContext(StoreContext);
  const converge = useSeekaConverge();
  const { sku, unitPrice, categoryName } = props;

  function addToCart(e) {
    e.preventDefault();
    addVariantToCart(variantId, quantity);
    // Track the Add to Cart event with Converge
    if (converge) {
      converge.track.addToCart({
        currencyCode: 'SGD', 
        productIdentifier: product.id, 
        variantIdentifier: variantId, // Assuming variantId is available as prop
        sku: sku,
        productName: title, 
        categoryName: categoryName,
        brandName: vendor, 
        unitPrice: unitPrice,
        quantity: quantity, 
        totalInventory: product.totalInventory || 0,
        totalDiscount: 0, 
        lineItemIdentifier: '', // You might need to replace this with an actual line item identifier if available
      });
    }
  }

return (
  <button
    type="submit"
    className={addToCartStyle}
    onClick={addToCart}
    disabled={!available || loading}
    {...props}
  >
    {available ? "Purchase" : "Out of Stock"}
  </button>
);
}